import { render, staticRenderFns } from "./AddSchool.vue?vue&type=template&id=514b3cf7&"
import script from "./AddSchool.vue?vue&type=script&lang=ts&"
export * from "./AddSchool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports